import SectionFullSlider from "@components/global/SectionFullSlider"
import { linkOurCommitment } from "src/helper/page-url"
import { convertJson, imgUrl } from "src/mixins"

export default function OurCommitmentSocial({ data, locale }) {
  return (
    <SectionFullSlider
      sectionName="sc-our-commitment-social"
      data={convertJson(data?.items)?.map((item) => ({
        label: data[`section_title_${locale}`],
        title: item[`title_${locale}`],
        text: item[`description_${locale}`],
        img: imgUrl(item.banner_image_desktop),
        imgMd: imgUrl(item.banner_image_mobile),
        imgOverlay: 50,
        link: `${linkOurCommitment}/social-initiative`,
      }))}
    />
  )
}
